// extracted by mini-css-extract-plugin
module.exports = {"container":"Tooltip_container__1X6O_","tooltip":"Tooltip_tooltip__1V2IT","fadeInFromNone":"Tooltip_fadeInFromNone__3lxUh","hide":"Tooltip_hide__hMMzA","icon":"Tooltip_icon__2-C_K"};